import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import EEStudentDashboard from '../../components/EEStudentDashboard';

const navigations = [withModules, courseWrapper, EEStudentDashboard];

export default navigations;
